import {DefaultButton, Panel, PanelType} from "@fluentui/react";
import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {IComment} from "../../model/FlexibleAttributeModel";
import {TextField} from "@fluentui/react/lib/TextField";

const UnderwritingComments  = (props: any) => {
   // {onSave} = props;
    const comment = useSelector((state: any) => state.comp.commentEdit) as IComment;
    const [commentstring, setComment] = useState<string>(comment.comment || "")
    useEffect(() => {
        if (!props.isOpen) {
            setComment("");
        }
        if(props.isOpen){
            setComment(comment.comment);
        }
    }, [props.isOpen]);
    return  (
        <Panel
            isOpen={props.isOpen}
            onDismiss={props.dismissPanel}
            type={PanelType.medium}
            closeButtonAriaLabel="Close"
            headerText="Add or Edit Comment">
            <TextField
                label="Comment"
                multiline
                rows={4}
                defaultValue={commentstring}
                onChange={(event, value) => {setComment(value || "")}}
                value={commentstring}
            />
                <DefaultButton onClick={() => {props.onSave(commentstring)}} text={'Add/Update Comment'} />
        </Panel>
    );
}

export default  UnderwritingComments;